<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
        <h2>Print Map</h2>
        <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="title">
                  <h4>Print Options</h4>
                  <span> </span>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">Title</label>
                    <input id="title" name="title" [(ngModel)]="title">
                  </div>
                  <div>
                    <label for="">Information</label>
                    <input id="information" name="information" [(ngModel)]="information">
                  </div>
                  <div>
                    <label for="">Legend Position</label>
                    <select (change)="legendPosition=$event.target.value">
                      <option value="upperLeft" selected>Upper Left Corner</option>
                      <option value="upperRight">Upper Right Corner</option>
                      <option value="lowerRight">Lower Right Corner</option>
                      <option value="lowerLeft">Lower Left Corner</option>
                    </select>
                  </div>
                  <div style="margin-top: 5px;">
                    <input type="checkbox" (change)="this.drawFullLegend = !drawFullLegend" checked>
                    <label for="">Draw full legend</label>
                  </div>
                  <div style="margin-top: 5px;">
                    <input type="checkbox" (change)="this.drawCalculationIdLegend = !drawCalculationIdLegend" [disabled]="this.drawFullLegend" checked>
                    <label for="">Draw calculation id legend</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button
                type="submit"
                [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
                (click)="ok(); ngForm.reset()"
                [disabled]="!ngForm.form.valid"
              >
                Ok
              </button>
              <button class="blue" (click)="preview()">Preview</button>
              <a class="gray" href="#" type="reset" (click)="cancel()" value="Cancel">Cancel</a>
            </div>
          </form>
        </div>
    </div>
  </div>
  <a id="image-download" download="map.png"></a>
</div>
